<script>
import StakeholderService from "@/services/StakeholderService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        value: {},
        field: {},
        fieldId: {},
        customColumnId: {
            type: Number,
            default: null
        },
        existingCustomValues: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            editing: false,
            tmp_value: "",
            saving: false,
            error: false
        };
    },
    computed: {
        fieldType() {
            return "textarea";
            if (this.field == "note") {
                return "textarea";
            } else {
                return "text";
            }
        }
    },
    watch: {
        value(oldV, newV) {
            if (this.saving != true) {
                return;
            }

            if (this.value == this.tmp_value) {
                this.saving = false;
            }
        }
    },
    methods: {
        startEditing() {
            this.tmp_value = Cloner.clone(this.value);
            this.editing = true;
        },
        async updateField() {
            try {
                this.error = false;
                this.saving = true;
                this.editing = false;

                let entity;
                if (this.customColumnId) {
                    // Custom column value - merge with existing values
                    const custom_values = this.existingCustomValues
                        .filter(
                            cv =>
                                cv.stakeholder_custom_column_id !==
                                this.customColumnId
                        )
                        .map(cv => ({
                            stakeholder_custom_column_id:
                                cv.stakeholder_custom_column_id,
                            col_value: cv.col_value
                        }));
                    // Add the updated value
                    custom_values.push({
                        stakeholder_custom_column_id: this.customColumnId,
                        col_value: this.tmp_value
                    });
                    entity = {
                        id: this.fieldId,
                        custom_values
                    };
                } else {
                    // Regular field
                    entity = {
                        id: this.fieldId,
                        [this.field]: this.tmp_value
                    };
                }

                await StakeholderService["PUT"](entity);
                this.$emit("save");
            } catch (e) {
                this.saving = false;
                this.editing = true;
                this.error = true;
                console.log("EX updateField", e);
            }
        }
    }
};
</script>

<template>
    <div class="v-inline-stakeholder-editor">
        <template v-if="editing">
            <textarea v-model="tmp_value" class="editing-element"></textarea>
            <div class="alert alert-danger mt-2" v-if="error">
                {{ $t("stakeholders.general_error_update_inline") }}
            </div>
            <div class="d-flex mt-2">
                <div class="eq mr-1">
                    <base-button
                        size="sm"
                        type="danger"
                        outline
                        block
                        @click="editing = false"
                        ><i class="far fa-times"></i
                    ></base-button>
                </div>
                <div class="eq ml-1">
                    <base-button
                        size="sm"
                        type="primary"
                        outline
                        block
                        @click="updateField"
                        ><i class="far fa-save"></i
                    ></base-button>
                </div>
            </div>
        </template>
        <template v-else
            ><i v-if="saving" class="fad fa-pulse fa-spinner"></i
            ><span
                v-else
                @click="startEditing"
                class="inline-value"
                :class="{ 'is-empty': !value }"
                ><template v-if="value">{{ value }}</template
                ><i v-else class="far fa-pen text-muted"></i
            ></span>
        </template>
    </div>
</template>

<style lang="scss">
.v-inline-stakeholder-editor {
    .eq {
        width: 50%;
    }

    .alert {
        font-size: 12px;
        padding: 5px;
    }

    .editing-element {
        width: 100%;
        border: 1px solid $gray-300;
        border-radius: 6px;
    }

    .inline-value {
        cursor: pointer;
        white-space: pre-line;

        &.is-empty {
            opacity: 0.4;
            &:hover {
                opacity: 0.7;
            }
        }
    }
}
</style>
